import { Provider } from "react-redux";
import { store } from "../store";
import { ThemeProvider } from "@/shared/theme/ThemeProvider";
import { AuthInitializer } from "@/modules/auth/components/AuthInitializer";

interface AppProvidersProps {
  children: React.ReactNode;
}

function AppProviders({ children }: AppProvidersProps) {
  return (
    <Provider store={store}>
      <AuthInitializer />
      <ThemeProvider>{children}</ThemeProvider>
    </Provider>
  );
}

export default AppProviders;
